var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { deepmerge } from '@mui/utils';
export var createTypography = function (overrides, tokens) {
    if (overrides === void 0) { overrides = {}; }
    var fontFamily = overrides.fontFamily || tokens.type_body_100.fontFamily;
    var fontFamilyMonospace = overrides.fontFamilyMonospace || tokens.type_global_monospace_10.fontFamily;
    var fontWeightMapping = {
        light: overrides.fontWeightLight || 300,
        regular: overrides.fontWeightRegular || 400,
        medium: overrides.fontWeightMedium || 500,
        semibold: overrides.fontWeightSemibold || 600,
        bold: overrides.fontWeightBold || 700,
    };
    var defaultOptions = {
        fontWeightMedium: fontWeightMapping.medium,
        fontWeightBold: fontWeightMapping.bold,
        fontWeightLight: fontWeightMapping.light,
        fontWeightRegular: fontWeightMapping.regular,
        fontWeightSemibold: fontWeightMapping.semibold,
        fontFamily: fontFamily,
        fontFamilyMonospace: fontFamilyMonospace,
        h1: tokens.type_heading_500,
        h2: tokens.type_heading_400,
        h3: tokens.type_heading_300,
        h4: tokens.type_heading_200,
        h5: tokens.type_heading_100,
        h6: tokens.type_body_300_emphasis,
        subtitle1: tokens.type_body_200_emphasis,
        subtitle2: tokens.type_body_100_emphasis,
        body1: tokens.type_body_200,
        body2: tokens.type_body_100,
        button: __assign(__assign({}, tokens.type_preset_button), { textTransform: 'capitalize' }),
        caption: tokens.type_preset_caption,
        overline: tokens.type_preset_overline,
        code1: tokens.type_code_100,
        code2: tokens.type_code_50,
        label: tokens.type_preset_form_label,
        input: tokens.type_preset_form_text,
    };
    return deepmerge(defaultOptions, overrides);
};
